/*
|--------------------------------------------------------------------------
| Modernizer
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.modernizr = {
	"init": function(){

		// add modernizr tests to check behavior and replace if it's not supported
	}

};
